import { render } from "./SwdLeadSubHeader.vue?vue&type=template&id=e6fb04fa"
import script from "./SwdLeadSubHeader.vue?vue&type=script&lang=js"
export * from "./SwdLeadSubHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__